import * as React from 'react';
const IFRStreamItemV2 = ({ story }) => {
    return (React.createElement("div", { style: {
            display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', width: '100%',
        } },
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("p", null,
                story.date.toLocaleString(),
                ' ',
                "-",
                ' ',
                story.headline))));
};
export default IFRStreamItemV2;
